import type { AnchorHTMLAttributes, MouseEvent } from 'react'
import { useRouter } from './Router.tsx'

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }

export const Link = ({ href, onClick, children, ...rest }: Props) => {
	const { navigate } = useRouter()
	const handle = (e: MouseEvent<HTMLAnchorElement>) => {
		onClick?.(e)
		if (e.defaultPrevented) return
		if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return
		e.preventDefault()
		navigate(href)
	}
	return (
		<a href={href} onClick={handle} {...rest}>
			{children}
		</a>
	)
}
